import { format } from "@konata9/milk-shake"
import { decamelize } from "humps"
import { v4 } from "uuid"

const InvokeName = "invoke"
const callbackName = "onCallResponse"
const eventName = "onEvent"
const globalVar = window as any

// const globalVar = {navigator:{userAgent:''},SunmiJSBridge:{[InvokeName]:function(params:any){
//   setTimeout(function(){
//     onCallBack(params)
//   },1000)
// }}} as any//:window
/**
 * 判断浏览器所属操作系统
 * @returns
 */
function isIos(): boolean {
  let u = globalVar.navigator.userAgent
  // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
  let isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  if (isIos) {
    return true
  } else {
    return false
  }
}

/**
 * 全局注入
 * @param data
 * @returns
 */
function registerGlobal(data: { [key: string]: any }) {
  if (callbackPool.inited) return
  callbackPool.inited = true
  callbackPool.isIos = isIos()
  Object.keys(data).forEach((key) => {
    globalVar[key as any] = data[key]
  })
}

function onCallBack(json = "{}") {
  const response = JSON.parse(json)
  const { msg_id } = response
  if (callbackPool.waitData[msg_id]) {
    callbackPool.waitData[msg_id].callback(response)
  }
}

function onEvent(json = "{}") {
  const response = JSON.parse(json)
  const { eventKey, event_key, params } = response
  const key = event_key || eventKey
  if (eventKey && callbackPool.listener[key]) {
    callbackPool.listener[key](params)
  }
}

const callbackPool = {
  //初始化标记
  inited: false,
  isIos: false,
  //回调池
  waitData: {} as {
    [key: string]: {
      timehandle: any
      callback: Function
    }
  },
  listener: {} as { [key: string]: Function },
}

/**
 * 调用代理
 * @param payload
 */
function callProxy(payload: any) {
  const obj = globalVar as any
  if (callbackPool.isIos) {
    obj.webkit.messageHandlers[InvokeName].postMessage(payload || "")
  } else {
    obj.SunmiJSBridge[InvokeName](payload)
  }
}

/**
 * 调用值内容
 * @param fnName 函数名称
 * @param param 参数
 * @returns
 */
function callNative(fnName: string, param: any, timeout: number) {
  registerGlobal({ [callbackName]: onCallBack, [eventName]: onEvent })
  return new Promise<any>((resolve, reject) => {
    try {
      const msgId = v4()
      const payload = JSON.stringify(
        format("toSnake")({ msgId, event: decamelize(fnName), param })
      )
      callbackPool.waitData[msgId] = {
        timehandle: setTimeout(() => {
          //超时
          if (callbackPool.waitData[msgId]) {
            delete callbackPool.waitData[msgId]
            reject({ code: -1, msg: "Time out" })
          }
        }, timeout),
        callback: function (data: any) {
          clearTimeout(callbackPool.waitData[msgId].timehandle)
          delete callbackPool.waitData[msgId]
          resolve(data)
        },
      }

      callProxy(payload)
    } catch (e) {
      reject({ code: -2, msg: e })
    }
  })
}

/**
 * 调用native入口
 * @param fnName 方法名
 * @param params 参数
 * @returns
 */
export function callNativeInvoke(
  fnName: string,
  params?: { [key: string]: any }
) {
  //从params中提取超时时长
  const timeout = params?.timeout || 5000
  if (params?.timeout) {
    delete params?.timeout
  }
  if (typeof params?.params == "function") {
    return addListener(fnName, params)
  }

  return callNative(fnName, params, timeout)
}

/**
 * 增加侦听事件
 * @param fnName
 * @param param
 * @returns
 */

async function addListener(fnName: string, param?: { [key: string]: any }) {
  registerGlobal({ [callbackName]: onCallBack, [eventName]: onEvent })
  return new Promise<string>((resolve, reject) => {
    try {
      const msgId = v4()
      const evtId = v4()
      if (param?.params) {
        callbackPool.listener[evtId] = param.params
        param.params = { eventKey: evtId }
      }

      const payload = JSON.stringify(
        format("toSnake")({ msgId, event: decamelize(fnName), param })
      )
      callProxy(payload)
      resolve(evtId)
    } catch (e) {
      reject({ code: -2, msg: e })
    }
  })
}

export function removeListener(eventKey: string) {
  if (eventKey && callbackPool.listener[eventKey]) {
    delete callbackPool.listener[eventKey]
  }
}
